import { getCategorySubcategoryGoalRatingAvg } from './getCategorySubcategoryGoalRatingAvg'
/**
 * Get the average of goal ratings for a category
 */
export const getCategorySubcategoryGoalRatingsAvg = (frameworkId, compassId, compassCategories) => {
  if (!compassId || !compassCategories || compassCategories.length === 0) {
    return compassCategories.map(() => 0)
  }
  return compassCategories.map(compassCategory => {
    return getCategorySubcategoryGoalRatingAvg(frameworkId, compassId, compassCategory.id)
  })
}
